import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './TextInputMaskCpfCnpj.styles';
import { Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';

const ALPHA_FORMAT_CHARS = { a: '[A-Za-z0-9]', '9': '[0-9]' };

const hasLetters = (value) => /[A-Za-z]/.test(value);
const cleanDoc = (value) => (value || '').replace(/[.\-/\s]/g, '');

const getMask = (value) => {
  const clean = cleanDoc(value);
  if (hasLetters(clean)) {
    return { mask: 'aa.aaa.aaa/aaaa-99', formatChars: ALPHA_FORMAT_CHARS };
  }
  if (clean.length > 11) {
    return { mask: '99.999.999/9999-99', formatChars: undefined };
  }
  return { mask: '999.999.999-99', formatChars: undefined };
};

export default function TextInputMaskCpfCnpj({
  label,
  name,
  width,
  height,
  variant = 'standard',
  multiline,
  control,
  margin,
  type,
  inputProps,
  maxRows,
  minRows,
  required = false,
  spacelabelinput,
}) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const { mask, formatChars } = getMask(field.value);
        return (
          <InputMask
            mask={mask}
            maskChar=""
            formatChars={formatChars}
            {...field}
            onChange={(e) => {
              field.onChange({ ...e, target: { ...e.target, value: e.target.value.toUpperCase() } });
            }}
          >
            {() => (
              <Styled.Text
                type={type ? type : 'text'}
                label={label}
                width={width}
                height={height}
                variant={variant}
                multiline={multiline}
                maxRows={maxRows}
                minRows={minRows}
                required={required}
                margin={margin}
                inputProps={inputProps}
                spacelabelinput={spacelabelinput}
              />
            )}
          </InputMask>
        );
      }}
    ></Controller>
  );
}

TextInputMaskCpfCnpj.propTypes = {
  setFilter: PropTypes.func,
  label: PropTypes.string,
  name: PropTypes.string,
  filter: PropTypes.object,
  width: PropTypes.string,
  height: PropTypes.string,
  variant: PropTypes.string,
  multiline: PropTypes.bool,
  control: PropTypes.any,
  margin: PropTypes.string,
  type: PropTypes.string,
  inputProps: PropTypes.object,
  maxRows: PropTypes.number,
  minRows: PropTypes.number,
  onChange: PropTypes.func,
  required: PropTypes.bool,
};
